import React, { useEffect, useState } from "react";
import "../css/add-property.css";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import {
  Btn,
  FormInput,
  FormTextArea,
  SelectInput2,
  SuccessComp,
} from "../../utils/utils";
import cloud from "../../assets/cloud.png";
import { AxiosAuthPost, uploadFileToCdn } from "../../api/api";
import {
  propCat,
  commCat,
  propType,
  propUse,
  state,
} from "../../utils/ExportObjects";
import { Add, Trash } from "iconsax-react";

const AddProperty = () => {
  const url = "agent/properties/";
  const userData = JSON.parse(localStorage?.getItem("apk"))?.data;
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isImgLoading, setIsImgLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [amenities, setAmenities] = useState([]);
  const [catArr, setCatArr] = useState([]);
  const [data, setData] = useState({
    name: "",
    propertyType: "",
    propertyUse: "",
    propertyCategory: "",
    propertyPrice: 0,
    propertyDescription: "",
    propertyAddress: "",
    area: "",
    city: "",
    state: "",
    numberOfUnits: "",
    yearBuilt: 0,
    amenities: "",
    longitude: 0,
    latitude: 0,
    bathrooms: 0,
    bedrooms: 0,
    pictures: [],
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    propertyType: "",
    propertyUse: "",
    propertyCategory: "",
    propertyPrice: "",
    propertyDescription: "",
    propertyAddress: "",
    area: "",
    city: "",
    state: "",
    numberOfUnits: "",
    yearBuilt: "",
    amenities: "",
    longitude: "",
    latitude: "",
    bathrooms: "",
    bedrooms: "",
    pictures: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
  };
  const addAmen = () => {
    if (data.amenities !== "") {
      setAmenities((prev) => {
        return [...prev, data.amenities];
      });
      setData((prev) => ({
        ...prev,
        amenities: "",
      }));
    } else {
      setDataErr((prev) => ({
        ...prev,
        amenities: "Field cannnot be empty",
      }));
    }
  };

  const rmAmen = (indexToRemove) => {
    setAmenities((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length + images.length > 5) {
      alert("You can only upload up to 5 images.");
      return;
    }
    setIsImgLoading(true);
    try {
      const uploadPromises = files.map((file) =>
        uploadFileToCdn(file, `PrimeProperty/agents/${userData.id}`),
      );

      const uploadedLinks = await Promise.all(uploadPromises);

      const validLinks = uploadedLinks.filter(Boolean);

      setImages((prev) => [...prev, ...validLinks]);
      setIsImgLoading(false);
    } catch (err) {
      // console.error("Upload failed:", err);
      setIsImgLoading(false);
    }
  };

  const options = state;

  const propTypeArr = propType;
  const propUseArr = propUse;
  const propCatArr = catArr;

  const selectPropType = (value) => {
    setData({
      ...data,
      propertyType: value,
    });
  };
  const selectPropUse = (value) => {
    setData({
      ...data,
      propertyUse: value,
    });
  };
  const selectPropCat = (value) => {
    setData({
      ...data,
      propertyCategory: value,
    });
  };
  const selectPropState = (value) => {
    setData({
      ...data,
      state: value,
    });
  };

  useEffect(() => {
    if (data?.propertyUse === "Residential") {
      setCatArr(propCat);
    } else {
      setCatArr(commCat);
    }
  }, [data?.propertyUse]);

  const dataObj = {
    name: data?.name,
    propertyType: data?.propertyType,
    propertyUse: data?.propertyUse,
    propertyCategory: data?.propertyCategory,
    propertyPrice: data?.propertyPrice,
    propertyDescription: data?.propertyDescription,
    propertyAddress: data?.propertyAddress,
    area: data?.area,
    city: data?.city,
    state: data?.state,
    numberOfUnits: data?.numberOfUnits,
    yearBuilt: data?.yearBuilt,
    amenities: amenities,
    longitude: data?.longitude,
    latitude: data?.latitude,
    bathrooms: data?.bathrooms,
    bedrooms: data?.bedrooms,
    pictures: images,
  };

  const addProp = () => {
    setIsLoading(true);
    AxiosAuthPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setData({
          name: "",
          propertyType: "",
          propertyUse: "",
          propertyCategory: "",
          propertyPrice: 0,
          propertyDescription: "",
          propertyAddress: "",
          area: "",
          city: "",
          state: "",
          numberOfUnits: "",
          yearBuilt: 0,
          amenities: "",
          longitude: 0,
          latitude: 0,
          bathrooms: 0,
          bedrooms: 0,
          pictures: [],
        });
        setImages([]);
        setAmenities([]);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        setTimeout(() => {
          setSuccessMsg("");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setImages([]);
        setIsLoading(false);
      });
  };

  return (
    <>
      <SuccessComp message={successMsg} />
      <AgentHeader
        header={`Add Property`}
        // placeholder={"Search for Property"}
      />
      <div className="property">
        <div className="property-info prop-form_cont">
          <h3>Property Information</h3>
          <div className="prop-form">
            <FormInput
              label={"Property Name"}
              id={"name"}
              value={data.name}
              changeInput={dataChange}
              err={dataErr.name}
            />
            <div className="prop-form_flex">
              <SelectInput2
                label={"Property Type"}
                options={propTypeArr}
                onChange={selectPropType}
                id={"propertyType"}
                err={dataErr.propertyType}
              />
              <SelectInput2
                label={"Property Use"}
                options={propUseArr}
                onChange={selectPropUse}
                err={dataErr.propertyUse}
              />
              <SelectInput2
                label={"Property Category"}
                options={propCatArr}
                onChange={selectPropCat}
                err={dataErr.propertyCategory}
              />
            </div>
            <FormInput
              label={"Property Price"}
              id={"propertyPrice"}
              value={data.propertyPrice}
              changeInput={dataChange}
              err={dataErr.propertyPrice}
            />
            <FormInput
              label={"No of bedrooms"}
              id={"bedrooms"}
              value={data.bedrooms}
              changeInput={dataChange}
              err={dataErr.bedrooms}
            />
            <FormInput
              label={"No of bathrooms"}
              id={"bathrooms"}
              value={data.bathrooms}
              changeInput={dataChange}
              err={dataErr.bathrooms}
            />
          </div>
        </div>
        <div className="property-details prop-form_cont">
          <h3>Property Details</h3>
          <div className="prop-form">
            <FormTextArea
              label={"Property Description"}
              id={"propertyDescription"}
              value={data.propertyDescription}
              changeInput={dataChange}
              err={dataErr.propertyDescription}
            />
            <FormInput
              label={"Property Address"}
              id={"propertyAddress"}
              value={data.propertyAddress}
              changeInput={dataChange}
              err={dataErr.propertyAddress}
            />
            <div className="prop-form_flex">
              <FormInput
                label={"Area"}
                id={"area"}
                value={data.area}
                type={"Number"}
                changeInput={dataChange}
                err={dataErr.area}
              />
              <FormInput
                label={"City/LGA"}
                id={"city"}
                value={data.city}
                changeInput={dataChange}
                err={dataErr.city}
              />
              <SelectInput2
                label={"State"}
                options={options}
                onChange={selectPropState}
                err={dataErr.state}
              />
            </div>
          </div>
        </div>
        <div className="amenities prop-form_cont">
          <h3>Amenities</h3>
          <div className="prop-form">
            <div className="prop-form_flex">
              <FormInput
                label={"No of Units"}
                id={"numberOfUnits"}
                value={data.numberOfUnits}
                changeInput={dataChange}
                err={dataErr.numberOfUnits}
              />
              <FormInput
                label={"Year Built"}
                id={"yearBuilt"}
                value={data.yearBuilt}
                changeInput={dataChange}
                err={dataErr.yearBuilt}
              />
            </div>
            {/* <FormInput
              label={"List Available Amenities"}
              id={"availableAmmenities"}
              value={data.amenities}
              changeInput={dataChange}
              err={dataErr.amenities}
            /> */}
            {amenities.map((item, idx) => {
              return (
                item && (
                  <div key={idx} className="filled_blks">
                    <p>{item}</p>
                    <Trash
                      color="#444444"
                      size={24}
                      onClick={() => rmAmen(idx)}
                      cursor={"pointer"}
                    />
                  </div>
                )
              );
            })}
            <div className="amenities_inp">
              <div className="amen_in">
                <FormInput
                  label={"Amenities"}
                  id={"amenities"}
                  changeInput={dataChange}
                  value={data.amenities}
                  err={dataErr.amenities}
                />
              </div>
              <div className="amen_icon" onClick={addAmen}>
                <Add size={24} color="#000000" />
              </div>
            </div>
          </div>
        </div>
        <div className="images prop-form_cont">
          <h3>Images</h3>
          <label htmlFor="picture" className="prop-form img-upload">
            {!isImgLoading && (
              <>
                <input
                  type="file"
                  name="picture"
                  id="picture"
                  style={{ display: "none" }}
                  multiple
                  accept=".png, .jpg, .gif, .svg"
                  onChange={handleFileChange}
                />
                <img src={cloud} alt="upload" />
                <p>
                  <span>Click to upload</span> <br />
                  SVG, PNG, JPG or GIF (max. 800x400px) <br />
                  Upload max. 5 in total
                </p>
              </>
            )}
            {isImgLoading && <h3>Please wait...</h3>}
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="preview"
                  width="100"
                  height="100"
                  style={{ objectFit: "cover", borderRadius: "5px" }}
                />
              ))}
            </div>
          </label>
          {dataErr?.pictures && (
            <p style={{ color: "red" }}>{dataErr.pictures}</p>
          )}
        </div>
        <div className="property-btn">
          <Btn
            btnClass={"home-btn"}
            btnText={`Add Property`}
            btnClick={addProp}
            loading={isLoading}
          />
        </div>
      </div>
    </>
  );
};

export default AddProperty;
